/* eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

let _debugEnabled = false;

let Debug = {
  setDebug(enabled) {
    _debugEnabled = enabled;
  },
  log: (msg) => {
    if (_debugEnabled) {
      console.log('[adminx_onboarding_ui] : ', msg);
    }
  },
  error: (msg) => {
    if (_debugEnabled) {
      console.error('[adminx_onboarding_ui] : ', msg);
    }
  },
};

export default Debug;
